import React from 'react';
import { Flex } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from '@bettercomp/ui-components';

import { SurveySeasonIllustration } from './SurveySeasonIllustration';
import { SurveySeasonBadge } from './SurveySeasonBadge';
import cn from './styles.module.scss';

type NotStartedBannerProps = {
  onGetStarted?: () => void;
  onClose?: () => void;
};

export function NotStartedBanner({ onGetStarted, onClose }: NotStartedBannerProps) {
  return (
    <Flex align="center" gap="large" className={cn.content}>
      <div className={cn.illustration}>
        <SurveySeasonIllustration />
      </div>
      <Flex vertical gap={8} className={cn.body}>
        <SurveySeasonBadge label="SURVEY RESULTS SEASON" />
        <h2 className={cn.title}>Get started on your next plan</h2>
        <p className={cn.description}>
          Pick the surveys you&apos;ll use this season. You can save your progress and come back anytime
          {' '}&mdash; the rest of the setup can wait until you&apos;re ready.
        </p>
      </Flex>
      <Flex align="center" gap={8} className={cn.action}>
        <Button
          type="primary"
          size="large"
          onClick={onGetStarted}
          data-testid="surveySeasonGetStartedButton"
          className={cn.ctaButton}
        >
          Get Started
        </Button>
        {onClose && (
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            data-testid="surveySeasonCloseButton"
            aria-label="Dismiss"
            className={cn.closeButton}
          />
        )}
      </Flex>
    </Flex>
  );
}
